import React from "react";
import "./skins.css";

export default function AlertHistorySkin({ alerts = [] }) {
  return (
    <section className="skin-card alert-history-skin">
      <header className="skin-card__header">
        <h3>오류/알림 이력</h3>
      </header>
      <div className="skin-card__body">
        {!alerts.length ? (
          <div className="skin-empty-inline">알림 이력이 없습니다.</div>
        ) : (
          <div className="alert-list">
            {alerts.map((alert, index) => (
              <article className="alert-item" key={`${alert.code || "alert"}-${index}`}>
                <strong>{alert.title}</strong>
                <div className="alert-item__meta">
                  <span>{alert.value_text || "-"}</span>
                  <span>{alert.triggered_at || "-"}</span>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
